{
  "version": 1,
  "asset_id": "09eec01c-b402-4731-b154-76b182e9381c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/09eec01c-b402-4731-b154-76b182e9381c/hiatal-type-3-sleeve-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/09eec01c-b402-4731-b154-76b182e9381c/hiatal-type-3-sleeve-es-800.webp",
  "original_filename": "hiatal-type-3-sleeve-es-800.webp",
  "size": 64160,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:11:07Z"
}
